import { useSelector } from 'react-redux';
import { useTranslate } from './translation-hooks';
import {
  shouldDisplayUnavailableBannerSelector,
  unavailablePeriodCronSelector,
} from 'redux/selectors/config';
import { useEffect, useState } from 'react';
import { isValidCron } from 'cron-validator';
import { checkMonths } from '../utils/cron-utils';
import { UnavailabilityHook } from 'ts/types/unavailability.types';

export const useUnavailabilityBanner = (): UnavailabilityHook => {
  const t = useTranslate('caseOpening');
  const unavailabilityPeriod = useSelector(unavailablePeriodCronSelector);
  const shouldDisplayUnavailableBanner = useSelector(
    shouldDisplayUnavailableBannerSelector,
  );
  const [showUnavailabilityBanner, setShowUnavailabilityBanner] =
    useState(false);

  useEffect(() => {
    if (shouldDisplayUnavailableBanner && unavailabilityPeriod) {
      setShowUnavailabilityBanner(
        unavailabilityPeriod
          .split('|')
          .filter(cronExpression =>
            isValidCron(cronExpression, { seconds: true }),
          )
          .some(cron => {
            const currentDate = new Date();
            const fields = cron.split(' ');
            const hours = fields[2].split(',');
            const months = fields[4].split(',');
            const weekDays = fields[5].split(',');
            return checkMonths({ currentDate, months, weekDays, hours });
          }),
      );
    }
  }, [shouldDisplayUnavailableBanner, unavailabilityPeriod]);

  return {
    title: t('unavailability_banner-title'),
    message: t('unavailability_banner-text'),
    showUnavailabilityBanner,
  };
};
